import React, { useMemo } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Image } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { RootStackParamList } from '../types/navigation';
import { useTheme } from '../styles/ThemeProvider';
import { useCommonStyles } from '../styles/useCommonStyles';

type Props = {
  navigation: NativeStackNavigationProp<RootStackParamList, 'Landing'>;
};

export default function LandingScreen({ navigation }: Props) {
  const theme = useTheme();
  const commonStyles = useCommonStyles();
  const styles = useMemo(
    () =>
      StyleSheet.create({
        content: {
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          paddingHorizontal: theme.spacing.xl,
        },
        logo: {
          width: 120,
          height: 120,
          marginBottom: theme.spacing.xl,
        },
        buttonContainer: {
          width: '100%',
          maxWidth: 400,
          gap: theme.spacing.xs,
          marginTop: theme.spacing.xl,
        },
        tagline: {
          ...theme.typography.sm,
          color: theme.colors.textSecondary,
          textAlign: 'center',
          marginTop: theme.spacing.xs,
          marginBottom: theme.spacing.lg,
        },
        signInButton: {
          marginTop: theme.spacing.md,
        },
      }),
    [theme],
  );

  return (
    <SafeAreaView style={commonStyles.safeArea}>
      <View style={commonStyles.screenContainer}>
        <View style={styles.content}>
          <Image
            source={require('../../public/app/cached-illustration.png')}
            style={styles.logo}
            resizeMode="contain"
          />
          <Text style={commonStyles.screenTitle}>Welcome to Cache</Text>
          <Text style={commonStyles.screenSubtitle}>
            Uncover the hidden value in your home
          </Text>

          <View style={styles.buttonContainer}>
            <TouchableOpacity
              style={commonStyles.primaryButton}
              onPress={() => navigation.navigate('Appraise')}
            >
              <Text style={commonStyles.primaryButtonText}>Value my stuff</Text>
            </TouchableOpacity>
            <Text style={styles.tagline}>AI-powered valuations. Instantly.</Text>

            <TouchableOpacity
              style={[commonStyles.secondaryButton, styles.signInButton]}
              onPress={() => navigation.navigate('SignIn', {})}
            >
              <Text style={commonStyles.secondaryButtonText}>Sign In</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </SafeAreaView>
  );
}
